/**
 * Build-time feature switches for the portal SPA.
 *
 * Read from Vite env at BUILD time, so flipping one requires a rebuild, not a
 * container restart — same as the API origins in .env.development.
 */

/**
 * Magic-link sign-in.
 *
 * Gated because the flow depends on infrastructure the SPA cannot see: it needs
 * BOTH `strao_portal/auth_hooks.py::on_magic_link_requested` (implemented as of
 * 2026-08-20) AND a configured SMTP relay (`STRAO_SMTP_HOST` / `_USERNAME` /
 * `_PASSWORD`). Without the relay, `email_service.create_email_service_from_env`
 * returns None and nothing is sent — while core's magic-link endpoint still
 * answers with its generic "If an account exists…" success. The UI would tell
 * the user to check an inbox that never receives anything, which is exactly the
 * misleading state this flag was introduced to prevent.
 *
 * So: set `VITE_MAGIC_LINK_ENABLED=true` in the env file for a deployment only
 * once SMTP is configured for that same deployment.
 */
export const MAGIC_LINK_ENABLED =
  import.meta.env.VITE_MAGIC_LINK_ENABLED === 'true';
